<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12qg0UF/tc-custom/9781540259981.jpg?1719576269456" alt="This image is the cover for the book St. Louis Gambling Kingpins, True Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">St. Louis Gambling Kingpins, True Crime
      </h1>
      <p class="bookDescription body article font2">
        <p>A history of betting on the East Side. Making it as a professional gambler in the first part of the twentieth century was a long shot, but wagering on the wide open scene of East St. Louis could help even the odds. Folks who were feeling lucky enough might grab a copy of Louis Cella's racing form, or get the inside scoop from turf men like Barney Schreiber. Students of the art of bookmaking had plentiful mentors in local legends like Adam "Mulepole" Fritz. But even then, a hot streak could attract the attention of a representative of the Chicago Outfit such as Frank "Buster" Wortman. The nephew of Vic and Jim Doyle, who built the Ringside Casino into the Midwest's largest casino, author James Doyle connects the dice rolls of bygone St. Louis Kingpins to high stakes players in New York and New Orleans.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James R. Doyle
      </h2>
      
      <p class="authorDescription body article">James R. Doyle is founder of St. Louis-based James R. Doyle Incorporated, which has delivered professional services to a national client base. He created and served as editor/publisher of the firm's banking publications, as well as author and project director for a number of contracted economic and land development studies. His present writing focus is on historical research dealing with social and economic changes that have affected communities throughout the United States.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23b86b9a